/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import { api } from "@/lib/api";
import Image from "next/image";
import { useEffect, useState } from "react";

const Jobs = () => {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    api
      .get("/Vacancy/Site")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar vagas:", error);
      });
  }, []);

  return (
    <>
      <section className="pt-28 lg:pt-10 pb-16"></section>
      <section className="py-16">
        <div className="container mx-auto">
          <div className="grid grid-cols-12 gap-y-10 lg:gap-10">
            <div className="col-span-12">
              <div className="job-list-header">
                <form action="#">
                  <div className="grid grid-cols-12 gap-3">
                    <div className="col-span-12 xl:col-span-3">
                      <div className="relative filler-job-form">
                        <i className="uil uil-location-point"></i>
                        <select
                          className="w-full form-select filter-job-input-box dark:text-gray-300"
                          data-trigger
                          name="choices-single-location"
                          id="choices-single-location"
                          aria-label="Default select example"
                        >
                          {[
                            ...new Set(data.map((item: any) => item.state)),
                          ].map((state: any) => (
                            <option key={state} value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-span-12 xl:col-span-3">
                      <div className="relative filler-job-form">
                        <i className="uil uil-location-point"></i>
                        <select
                          className="w-full form-select filter-job-input-box dark:text-gray-300"
                          data-trigger
                          name="choices-single-location"
                          id="choices-single-location"
                          aria-label="Default select example"
                        >
                          {[...new Set(data.map((item: any) => item.city))].map(
                            (city: any) => (
                              <option key={city} value={city}>
                                {city}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-span-12 xl:col-span-3">
                      <div className="relative filler-job-form">
                        <i className="uil uil-clipboard-notes"></i>
                        <select
                          className="w-full form-select filter-job-input-box dark:text-gray-300"
                          data-trigger
                          name="choices-single-categories"
                          id="choices-single-categories"
                          aria-label="Default select example"
                        >
                          {[
                            ...new Set(
                              data.map((item: any) => item.positionName)
                            ),
                          ].map((positionName: any) => (
                            <option key={positionName} value={positionName}>
                              {positionName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-span-12 xl:col-span-3">
                      <a
                        href="#"
                        className="btn-sc-primary w-full inline-flex items-center justify-center rounded-md py-3 font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0867d2] shadow-sm hover:shadow transition-colors"
                        style={{ textDecoration: "none" }}
                      >
                        <i className="uil uil-filter me-1" /> Filter
                      </a>
                    </div>
                  </div>
                </form>
              </div>

              <div className="mt-8 search-job"></div>

              <div className="grid grid-cols-12 gap-y-8 lg:gap-8">
                {data.map((item: any) => {
                  return (
                    <div
                      key={item?.id}
                      className="col-span-12 space-y-8 lg:col-span-6"
                    >
                      <div className="relative overflow-hidden transition-all duration-500 ease-in-out bg-white border rounded-md border-gray-100/50 group group-data-[theme-color=violet]:hover:border-violet-500 group-data-[theme-color=sky]:hover:border-sky-500 group-data-[theme-color=red]:hover:border-red-500 group-data-[theme-color=green]:hover:border-green-500 group-data-[theme-color=pink]:hover:border-pink-500 group-data-[theme-color=blue]:hover:border-blue-500 hover:-translate-y-2 dark:bg-neutral-900 dark:border-neutral-600">
                        <div className="p-6">
                          <div className="grid grid-cols-12 gap-5">
                            <div className="col-span-12 lg:col-span-2">
                              <div className="mb-4 text-center mb-md-0">
                                <Image
                                  src="/assets/images/user.png"
                                  width={120}
                                  height={120}
                                  alt=""
                                  className="md:mx-auto img-fluid rounded-3"
                                />
                              </div>
                            </div>
                            <div className="col-span-12 lg:col-span-10">
                              <h5 className="mb-1 fs-17">
                                <a href="#" className="dark:text-gray-50">
                                  {item?.positionName}
                                </a>
                                <small className="font-normal text-gray-500 dark:text-gray-300"></small>
                              </h5>
                              <ul className="flex flex-wrap mb-0 gap-y-3 lg:gap-3">
                                <li>
                                  <p className="mb-0 text-sm text-gray-500 dark:text-gray-300">
                                    {item?.name}
                                  </p>
                                </li>
                                <li>
                                  <p className="mb-0 text-sm text-gray-500 dark:text-gray-300">
                                    <i className="mdi mdi-map-marker"></i>{" "}
                                    {item?.state}
                                  </p>
                                </li>
                                {item?.rate > 0 && (
                                  <li>
                                    <p className="mb-0 text-sm text-gray-500 dark:text-gray-300">
                                      <i className="uil uil-wallet"></i> $
                                      {item?.rate} / h
                                    </p>
                                  </li>
                                )}
                              </ul>
                              <div className="mt-4">
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="bg-yellow-500/20 text-yellow-500 text-11 px-2 py-0.5 font-medium rounded">
                                    {item?.requirements}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="px-4 py-3 bg-gray-50 dark:bg-neutral-700">
                          <div className="grid grid-cols-12">
                            <div className="col-span-12 lg:col-span-6">
                              <ul className="flex flex-wrap gap-2 text-gray-700 dark:text-gray-50">
                                <li>
                                  <i className="uil uil-tag"></i> Status :
                                </li>
                                <li>{item?.status}</li>
                              </ul>
                            </div>
                            {/* <div className="col-span-12 mt-2 lg:col-span-6 lg:mt-0">
                                                            <div className="ltr:lg:text-right rtl:lg:text-left dark:text-gray-50">
                                                                <a href="#applyNow" data-bs-toggle="modal">Apply Now <i className="mdi mdi-chevron-double-right"></i></a>
                                                            </div>
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jobs;
